import {compose} from 'redux';
import React from 'react';

import {connectI18n} from '../../connects';
import LoadConnections from '../../loaders/LoadConnections';
import SendEmail from '../SendEmail';
import ValidateConnectionExists from './common/ValidateConnectionExists';
import WaitWhileBusy from '../../WaitWhileBusy';
import connectUserId from './common/connectUserId';

const ConnectedScreen = compose(
    connectI18n,
    connectUserId
)(SendEmail);

const SendEmailToContact = props => (
    <LoadConnections>
        <WaitWhileBusy>
            <ValidateConnectionExists {...props}>
                <ConnectedScreen {...props.match.params} />
            </ValidateConnectionExists>
        </WaitWhileBusy>
    </LoadConnections>
);

export default SendEmailToContact;
